<script setup lang="ts">
definePageMeta({
  layout: 'search',
})

useSetSEO()
</script>

<template>
  <NovaSearchResultDetailHashtag />
</template>

<style scoped lang="scss"></style>
